import styled from 'styled-components';

const Wrapper = styled.div`
	.btn-area {
		margin-top: 24px;
	}
	.ant-radio-group {
		width: 100%;
	}
	.ant-radio-wrapper {
		display: flex;
		align-items: top;
		padding: 12px;
		border: 1px solid transparent;
		margin: 4px 0;
		&.ant-radio-wrapper-checked {
			border-color: #00f;
		}
		p {
			margin: 0;
		}
		span.ant-radio + * {
			padding-right: 8px;
			padding-left: 8px;
			flex: 1;
		}
		.ant-radio-inner {
			top: 3px;
		}
	}
	.payment {
		position: relative;
		.payment-info {
			padding: 24px 0;
			padding-right: 150px;
			border-bottom: 1px solid #000;
		}
		.qr-code {
			position: absolute;
			right: 0;
			top: 12px;
			width: auto;
		}
		.currency-info {
			margin-top: 24px;
			position: relative;
			padding-right: 75px;

			min-height: 55px;
			.timer {
				position: absolute;
				left: 0;
				top: 0;
			}
			.disclamar {
				font-size: 10px;
				color: #747474;
			}

			p {
				margin: 0;
				line-height: 2;
			}
		}
	}
`;

export default Wrapper;
